import moment from "moment";
var DateHelper = /** @class */ (function () {
    function DateHelper() {
    }
    DateHelper.castDate = function (value) {
        if (value && (moment.isMoment(value))) {
            return value.toDate();
        }
        return typeof value === "string" ? new Date(value) : value;
    };
    return DateHelper;
}());
export { DateHelper };
